import { useTranslation } from 'react-i18next';
import { PractitionersForm, Practitioner } from 'components/EventForms';
import { Box } from '@mui/material';
import {
  SectionTitle,
  SvgSingleNeutralBold,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import FormNavigation from './FormNavigation';
import { StepProps } from './types';

const Practitioners = ({ onBack, onNext, event, updateEvent }: StepProps) => {
  const { t } = useTranslation();
  const onSubmit = (practitioners: Practitioner[]) => {
    updateEvent({
      ...event,
      practitioners,
    });
    onNext();
  };
  return (
    <>
      <Box
        sx={{
          mt: spacingSizeMap.L,
          mb: spacingSizeMap.L,
        }}
      >
        <SectionTitle
          icon={{ icon: <SvgSingleNeutralBold />, iconColour: 'blue' }}
          text={t('ui.event-management.events.edit.practitioners.header')}
        />
      </Box>
      <PractitionersForm event={event} onSubmit={onSubmit}>
        <FormNavigation onBack={onBack} />
      </PractitionersForm>
    </>
  );
};

export default Practitioners;
